export default {"src":"/_next/static/media/AMN.bbdd456c.svg","height":18,"width":18};